import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex, Text } from 'pcln-design-system'
import { User } from 'pcln-icons'

const NoWrapFlex = styled(Flex)`
  white-space: nowrap;
  cursor: pointer;
`

function SignIn ({ className, color, onLoginClicked }) {
  return (
    <NoWrapFlex
      className={className}
      alignItems='center'
      onClick={onLoginClicked}
    >
      <User mr={2} color={color} />
      <Text color={color}>Sign In</Text>
    </NoWrapFlex>
  )
}

SignIn.displayName = 'SignIn'

SignIn.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onLoginClicked: PropTypes.func
}

export default memo(SignIn)
